import React from "react";
import { Container } from "react-bootstrap";
import classes from './linkBlock.module.css';
import NewsItem from "./newsItem";

const NewsList = ({newsitems, title}) => {
    return(
        <Container fluid="md">
            <h2>{title}</h2>
            <div className={classes.newsList}>
                {newsitems.map((newsitem, index) =>
                    <NewsItem newsitem={newsitem} key={newsitem.id} number={index +1}/>
                )}
            </div>
        </Container>
    )
}

export default NewsList;